<script setup>
/**
 * AccountsMock — multi-account management in dark mode, as vector UI:
 * isolated accounts, member avatars, pack quota. Decorative.
 */
const ACCOUNTS = [
  { code: 'OA', name: 'Ooredoo Algérie', tag: 'Corporation', members: 3, events: 2 },
  { code: 'NN', name: 'Novo Nordisk', tag: 'Laboratoire', members: 5, events: 2 },
  { code: 'FF', name: 'Fédération Algérienne de Football', tag: 'Institution', members: 4, events: 2 }
]
const AVATARS = ['#38bdf8', '#a78bfa', '#f472b6', '#34d399', '#fbbf24']
</script>

<template>
  <div class="bg-[#171c2c] text-slate-200" aria-hidden="true">
    <div class="flex items-center justify-between px-5 pt-4 pb-3 border-b border-white/5">
      <div>
        <div class="text-[15px] font-semibold text-white">Comptes</div>
        <div class="text-[11px] text-slate-400" dir="ltr">Pack Entreprise · 4 comptes sur 5</div>
      </div>
      <span class="bg-gradient-to-r from-[#8e4ec6] to-[#c0397f] text-white rounded-md px-3 py-1.5 text-[11px] font-medium">Créer un compte</span>
    </div>

    <div class="divide-y divide-white/5">
      <div v-for="(a, i) in ACCOUNTS" :key="i" class="flex items-center gap-3.5 px-5 py-3.5">
        <span class="w-9 h-9 rounded-lg bg-[#6d4fc2] text-white text-[12px] font-semibold flex items-center justify-center shrink-0">{{ a.code }}</span>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <span class="text-[13px] font-semibold text-white truncate">{{ a.name }}</span>
            <span class="text-[9px] uppercase tracking-wider text-slate-400 border border-white/10 rounded px-1.5 py-px shrink-0">{{ a.tag }}</span>
          </div>
          <div class="text-[11px] text-slate-500" dir="ltr">{{ a.events }} événements</div>
        </div>
        <div class="flex -space-x-1.5 shrink-0" dir="ltr">
          <span v-for="m in a.members" :key="m"
            class="w-5.5 h-5.5 w-[22px] h-[22px] rounded-full border-2 border-[#171c2c] text-[8px] font-semibold text-slate-900 flex items-center justify-center"
            :style="`background:${AVATARS[(i + m) % AVATARS.length]}`">U</span>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between px-5 py-2.5 bg-white/[0.03] border-t border-white/5 text-[11px] text-slate-500">
      <span>Rôles : admin · manager · staff · hôtesse · client</span>
      <span>Données isolées par compte</span>
    </div>
  </div>
</template>
